import React, { useId } from 'react';

const Input = ({ 
  label, 
  error, 
  helperText, 
  className = '', 
  type = 'text',
  variant = 'default',
  fullWidth = false,
  required = false,
  ...props 
}) => {
  const inputId = useId();
  
  const baseInputClasses = 'block w-full rounded-md border-gray-300 shadow-sm focus:border-hemp-green-500 focus:ring-hemp-green-500 sm:text-sm transition-colors duration-200';
  
  const variantClasses = {
    default: 'border-gray-300',
    success: 'border-hemp-green-500 focus:border-hemp-green-500 focus:ring-hemp-green-500',
    warning: 'border-hemp-brown-500 focus:border-hemp-brown-500 focus:ring-hemp-brown-500',
    danger: 'border-red-500 focus:border-red-500 focus:ring-red-500'
  };
  
  const errorClasses = error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : '';
  
  const inputClasses = [
    baseInputClasses,
    variantClasses[variant],
    errorClasses,
    className
  ].filter(Boolean).join(' ');
  
  const containerClasses = fullWidth ? 'w-full' : '';
  
  return (
    <div className={containerClasses}>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      {type === 'textarea' ? (
        <textarea
          id={inputId}
          className={inputClasses}
          rows={4}
          {...props}
        />
      ) : (
        <input
          id={inputId}
          type={type}
          className={inputClasses}
          {...props}
        />
      )}
      
      {helperText && !error && (
        <p className="mt-1 text-sm text-gray-500">{helperText}</p>
      )}
      
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default Input;
